import PageModel, { PageKind } from '@mm/state/model/PageModel';
import AdAccountModel from '@mm/state/model/AdAccountModel';

export const getWelcomePage = (pages: PageModel[]) =>
  pages.find(page => page.kind === PageKind.WelcomePage);

export const timeout = (ms: number) =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export const randomId = () =>
  `${Math.random().toString(36).substring(4)}_${Math.random()
    .toString(36)
    .substring(4)}`;

export const addNamesToAccounts = (
  accounts?: AdAccountModel[],
): AdAccountModel[] =>
  (accounts || []).map(a => ({
    ...a,
    // Name is needed for the dropdown component we use
    name: `${a.name || ''} (${a.id.toString()})`,
  }));
